const ADVANCED_SETTINGS_COMMON_INFO = [
  {
    field: "Subset",
    value: "None",
  },
  {
    field: "Objective",
    value: "Balanced Accuracy",
  },
  {
    field: "Entropy Threshold",
    value: "Engine Default",
  },
  {
    field: "Stability Factor",
    value: "Engine Default",
  },
];

export { ADVANCED_SETTINGS_COMMON_INFO };
